<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue'

import { useRealmSettings } from '@/stores/useRealmSettings'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { realmSettings } = storeToRefs(useRealmSettings())

const mailToLink = computed(() => {
  return `mailto:${realmSettings.value?.email.technical_support_email}`
})
</script>

<template>
  <div>
    <PageTitle :title="$t('error-page.not-found.title')" />
    <div class="d-flex flex-column gap-4">
      <p class="text-center text-pre-wrap">
        {{ $t('error-page.not-found.message') }}
      </p>

      <v-btn variant="text" :href="mailToLink" target="_blank">{{
        $t('error-page.contact.button')
      }}</v-btn>
    </div>
  </div>
</template>
